<template>
    <!-- 员工基本信息 -->
    <div>
        <!-- <div style="font-size:20px;float:left;margin:40px;font-weight:600">员工基本信息</div> -->

        <!-- 列表 -->
        <div style="height:auto;background-color:white;margin:5px 5px 20px 5px;padding-bottom: 20px;">
            <!-- 查询框 -->
            <div style="margin-left:3%">
                <el-row style=" padding: 20px 0;">
                    <el-col :span="6">
                        <div style="display:inline-block">
                            <span>组织架构</span>
                            <el-cascader v-model="condition.organize_ids" clearable style="margin-left:10px;width:300px"
                                collapse-tags :props="props"></el-cascader>
                        </div>
                    </el-col>
                    <!-- <el-col :span="4">
                        <span>时间</span>
                        <el-date-picker v-model="condition.years_date" type="month" placeholder="请选择"
                            value-format="yyyy-MM" style="margin-left: 10px;width: 70%;">
                        </el-date-picker>
                    </el-col> -->
                    <el-col :span="3">
                        <el-button
                            style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
                            @click="Find">
                            查询</el-button>
                        <el-button
                            style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
                            @click="Update">
                            更新</el-button>
                    </el-col>
                    <el-col :span="2">
                        <download-excel class="export-excel-wrapper" :fields="download_excel" name="员工基本信息表"
                            :fetch="ExportForm" style="top:100px;width:5%">
                            <el-button
                                style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;">
                                导出</el-button>
                        </download-excel>
                    </el-col>
                </el-row>
            </div>

            <div style="margin: 5px 3% 0px;overflow-y:hidden;overflow-x: auto;">
                <div style="height: 370px;min-width: 1540px;">
                    <div style="border:1px solid #ccc;width: 35%;height: 370px;float: left;">
                        <div
                            style="margin-top: 20px;margin-left:20px;font-weight: 600;display: flex; align-items: center;">
                            <img src="../../../src/assets/小绿条.png"
                                style="width: 4px; height: 20px;margin-right: 8px;" />
                            <span>70岁（含）超龄员工数</span>
                        </div>

                        <div style="width: auto;height: 370px;" id="main1">
                        </div>
                    </div>
                    <div style="border:1px solid #ccc;width: 30%;height: 370px;float: left;margin: 0 1%;">
                        <div
                            style="margin-top: 20px;margin-left:20px;font-weight: 600;display: flex; align-items: center;">
                            <img src="../../../src/assets/小绿条.png"
                                style="width: 4px; height: 20px;margin-right: 8px;" />
                            <span>性别</span>
                        </div>

                        <div style="width: auto;height: 370px;" id="main2">
                        </div>
                    </div>
                    <div style="border:1px solid #ccc;width: 32.6%;height: 370px;float: right;">
                        <div
                            style="margin-top: 20px;margin-left:20px;font-weight: 600;display: flex; align-items: center;">
                            <img src="../../../src/assets/小绿条.png"
                                style="width: 4px; height: 20px;margin-right: 8px;" />
                            <span>司龄</span>
                        </div>

                        <div style="width: auto;height: 370px;" id="main3">
                        </div>
                    </div>

                    <div style="border:1px solid #ccc;width: 35%;height: 370px;float: left;margin:17px 1% 0 0;">
                        <div
                            style="margin-top: 20px;margin-left:20px;font-weight: 600;display: flex; align-items: center;">
                            <img src="../../../src/assets/小绿条.png"
                                style="width: 4px; height: 20px;margin-right: 8px;" />
                            <span>年龄</span>
                        </div>

                        <div style="width: auto;height: 370px;" id="main4">
                        </div>
                    </div>

                    <div style="border:1px solid #ccc;width: 63.7%;height: 370px;float: right;margin-top:17px;">
                        <div
                            style="margin-top: 20px;margin-left:20px;font-weight: 600;display: flex; align-items: center;">
                            <img src="../../../src/assets/小绿条.png"
                                style="width: 4px; height: 20px;margin-right: 8px;" />
                            <span>学历</span>
                        </div>

                        <div style="width: auto;height: 370px;" id="main5">
                        </div>
                    </div>
                </div>
            </div>

            <!-- 表格 -->
            <div style="margin:0 3%;margin-top:30px">
                <el-row>
                    <el-table :header-cell-style="{ background: '#d3eae2', color: '#000000' }" height="574px"
                        :row-class-name="tableRowClassName" ref="multipleTable" :data="tableData" tooltip-effect="dark"
                        style="width: 100%" @selection-change="handleSelectionChange">
                        <el-table-column align="center" label="序号">
                            <template slot-scope="scope_1">
                                {{ scope_1.$index + 1 }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="organize_name" align="center" label="架构">
                        </el-table-column>
                        <el-table-column align="center" label="70岁（含）超龄员工数">
                            <el-table-column prop="overage_manager" align="center" label="经理"></el-table-column>
                            <el-table-column prop="overage_executive" align="center" label="主管"></el-table-column>
                            <el-table-column prop="overage_staff" align="center" label="员工"></el-table-column>
                        </el-table-column>
                        <el-table-column align="center" label="性别">
                            <el-table-column prop="male" align="center" label="男"></el-table-column>
                            <el-table-column prop="female" align="center" label="女"></el-table-column>
                        </el-table-column>
                        <el-table-column align="center" label="司龄">
                            <el-table-column prop="working_years_1" align="center" label="0-1"></el-table-column>
                            <el-table-column prop="working_years_2" align="center" label="1-3"></el-table-column>
                            <el-table-column prop="working_years_3" align="center" label="3-5"></el-table-column>
                            <el-table-column prop="working_years_4" align="center" label="5-10"></el-table-column>
                            <el-table-column prop="working_years_5" align="center" label="10+"></el-table-column>
                        </el-table-column>
                        <el-table-column align="center" label="年龄">
                            <el-table-column prop="age_1" align="center" label="16-30"></el-table-column>
                            <el-table-column prop="age_2" align="center" label="30-50"></el-table-column>
                            <el-table-column prop="age_3" align="center" label="50-65"></el-table-column>
                            <el-table-column prop="age_4" align="center" label="65-70"></el-table-column>
                            <el-table-column prop="age_5" align="center" label="70+"></el-table-column>
                        </el-table-column>
                        <el-table-column align="center" label="学历">
                            <el-table-column prop="primary_school" align="center" label="小学"></el-table-column>
                            <el-table-column prop="junior_middle_school" align="center" label="初中"></el-table-column>
                            <el-table-column prop="technical_secondary_school" align="center" label="中专">
                            </el-table-column>
                            <el-table-column prop="senior_high_school" align="center" label="高中"></el-table-column>
                            <el-table-column prop="junior_college" align="center" label="大专"></el-table-column>
                            <el-table-column prop="university" align="center" label="大学"></el-table-column>
                        </el-table-column>
                    </el-table>
                </el-row>
                <el-row style="margin-top: 10px; text-align: center;">
                    <el-pagination background @current-change="handleCurrentChange" :page-size="page_size"
                        layout=" prev, pager, next, jumper" :total="total">
                    </el-pagination>
                </el-row>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import * as echarts from 'echarts';
export default {
    data() {
        var organizeFind = async (e, spare8) => {
            var organizeList = await this.$globals.AxiosPost("organize/findHierarchy", {
                identification: "1",
                organize_id: e,
                spare8: spare8,
            });
            return organizeList.data;
        };
        return {
            //列表相关
            page_num: 1,
            page_size: 10,
            total: 0,
            tableData: [],
            tableDatas: [],

            //组织架构数据
            organizeList: [],
            //条件
            condition: {
                organize_ids: []
            },

            //页面相关
            dialogVisible: false,

            download_excel: {
                "架构": "organize_name",
                "70岁（含）超龄员工数 - 经理": "overage_manager",
                "70岁（含）超龄员工数 - 主管": "overage_executive",
                "70岁（含）超龄员工数 - 员工": "overage_staff",
                "性别 - 男": "male",
                "性别 - 女": "female",
                "司龄 - 0-1": "working_years_1",
                "司龄 - 1-3": "working_years_2",
                "司龄 - 3-5": "working_years_3",
                "司龄 - 5-10": "working_years_4",
                "司龄 - 10+": "working_years_5",
                "年龄 - 16-30": "age_1",
                "年龄 - 30-50": "age_2",
                "年龄 - 50-65": "age_3",
                "年龄 - 65-70": "age_4",
                "年龄 - 70+": "age_5",
                "学历 - 小学": "primary_school",
                "学历 - 初中": "junior_middle_school",
                "学历 - 中专": "technical_secondary_school",
                "学历 - 高中": "senior_high_school",
                "学历 - 大专": "junior_college",
                "学历 - 大学": "university",
            },

            chart: {},
            //级联下拉配置
            props: {
                lazy: true,
                async lazyLoad(node, resolve) {
                    if (node.level === 0) {
                        return resolve(await organizeFind('', 'group'));
                    } else {
                        resolve(await organizeFind(node.data.id, ''));
                    }
                },
                value: "id",
                label: "organize_name",
                children: "organizeList",
                checkStrictly: true,
                multiple: true,
            },
        }
    },
    methods: {
        //分页
        handleCurrentChange(val) {
            this.page_num = val;
            this.Find();
        },

        async Find_Tu() {
            var url = "basicInformation/getReport";
            var data = await this.$globals.AxiosGet(url);
            if (data === "-2000") {
                this.$message.error("服务器未响应！请稍后重试");
            } else {
                var code = data.code;
                var data = data.data;
                if (code === '200') {
                    this.chart = data;
                    if (data == null) {
                        this.chart = [
                            {
                                overage_manager: "",
                                overage_executive: "",
                                overage_staff: "",
                                male: "",
                                female: "",
                                working_years_1: "",
                                working_years_2: "",
                                working_years_3: "",
                                working_years_4: "",
                                working_years_5: "",
                                age_1: "",
                                age_2: "",
                                age_3: "",
                                age_4: "",
                                age_5: "",
                                primary_school: "",
                                junior_middle_school: "",
                                technical_secondary_school: "",
                                senior_high_school: "",
                                junior_college: "",
                                university: ""
                            }
                        ]
                    }
                } else {
                    this.$message.warning("请求失败！请稍后重试");
                }
            }

            echarts.init(document.getElementById('main1')).setOption({
                grid: {
                    top: '60px',
                    left: '70px',
                    right: '40px',
                    bottom: '80px'
                },
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: 'none'
                    }
                },
                xAxis: {
                    type: 'category',
                    data: ['经理及以上', '主管', '员工']
                },
                yAxis: {
                    type: 'value'
                },
                series: [{
                    data: [this.chart.overage_manager, this.chart.overage_executive, this.chart.overage_staff],
                    type: 'bar',
                    barWidth: '20%',
                    color: '#008E60',
                }]
            })

            echarts.init(document.getElementById('main2')).setOption({
                grid: {
                    top: '50px',
                    left: '30px',
                    right: '40px',
                    bottom: '80px'
                },
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    orient: 'vertical',//设置图例的方向
                    right: 80,
                    top: 120,
                    itemGap: 30,//设置图例的间距
                    textStyle: {
                        //图例字体大小
                        fontSize: 18,
                    },
                },
                color: ['#3B8CF8', '#31C78A'],
                series: [{
                    data: [
                        { value: this.chart.male, name: '男' },
                        { value: this.chart.female, name: '女' }
                    ],
                    type: 'pie',
                    radius: ['35%', '60%'],
                    label: {
                        show: false,
                        position: 'center'
                    },
                    center: ['35%', '45%'],
                }]
            })
            echarts.init(document.getElementById('main3')).setOption({
                grid: {
                    top: '50px',
                    left: '30px',
                    right: '40px',
                    bottom: '80px'
                },
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    orient: 'vertical',//设置图例的方向
                    right: 70,
                    top: 55,
                    itemGap: 30,//设置图例的间距
                    textStyle: {
                        //图例字体大小
                        fontSize: 18,
                    },
                },
                color: ['#3B8CF8', '#31C78A', '#FFA43C', '#FD707C', '#584AFF'],
                series: [{
                    data: [
                        { value: this.chart.working_years_1, name: '0-1年' },
                        { value: this.chart.working_years_2, name: '1-3年' },
                        { value: this.chart.working_years_3, name: '3-5年' },
                        { value: this.chart.working_years_4, name: '5-10年' },
                        { value: this.chart.working_years_5, name: '10年以上' },

                    ],
                    type: 'pie',
                    radius: ['35%', '60%'],
                    label: {
                        show: false,
                        position: 'center'
                    },
                    center: ['32%', '45%'],
                }],
            })
            echarts.init(document.getElementById('main4')).setOption({
                grid: {
                    top: '50px',
                    left: '30px',
                    right: '40px',
                    bottom: '80px'
                },
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    orient: 'vertical',//设置图例的方向
                    right: 70,
                    top: 55,
                    itemGap: 30,//设置图例的间距
                    textStyle: {
                        //图例字体大小
                        fontSize: 18,
                    },
                },
                color: ['#3B8CF8', '#31C78A', '#FFA43C', '#FD707C', '#584AFF'],
                series: [{
                    data: [
                        { value: this.chart.age_1, name: '16-30岁' },
                        { value: this.chart.age_2, name: '30-50岁' },
                        { value: this.chart.age_3, name: '50-65岁' },
                        { value: this.chart.age_4, name: '65-70岁' },
                        { value: this.chart.age_5, name: '70岁以上' },

                    ],
                    type: 'pie',
                    radius: ['35%', '60%'],
                    label: {
                        show: false,
                        position: 'center'
                    },
                    center: ['32%', '45%'],
                }]
            })
            echarts.init(document.getElementById('main5')).setOption({
                grid: {
                    top: '50px',
                    left: '80px',
                    right: '40px',
                    bottom: '80px'
                },
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: 'none'
                    }
                },
                xAxis: {
                    type: 'category',
                    data: ['小学', '初中', '中专', '高中', '大专', '大学']
                },
                yAxis: {
                    type: 'value'
                },
                series: [{
                    data: [this.chart.primary_school, this.chart.junior_middle_school, this.chart.technical_secondary_school, this.chart.senior_high_school, this.chart.junior_college, this.chart.university],
                    type: 'bar',
                    barWidth: '20%',
                    color: '#008E60',
                }]
            })
        },
        //查询
        async Find() {
            this.Find_Tu();
            var url = "basicInformation/selectStaffBasicInformation";
            var record = {
                page_num: this.page_num,
                page_size: this.page_size,
                organizeIds_num: this.condition.organize_ids[this.condition.organize_ids.length - 1],
            };
            var data = await this.$globals.AxiosPost(url, record);
            if (data === "-2000") {
                this.$message.error("服务器未响应！请稍后重试");
            } else {
                var code = data.code;
                var data = data.data;
                if (code === '200') {
                    this.tableData = data.list;
                    this.total = data.total;
                } else {
                    this.$message.warning("请求失败！请稍后重试");
                }
            }
        },
        async Update() {
            var url = "basicInformation/refreshStaffBasicInformation";
            var data = await this.$globals.AxiosGet(url);
            if (data === "-2000") {
                this.$message.error("服务器未响应！请稍后重试");
            } else {
                var code = data.code;
                if (code === '200') {
                    this.tableData = [];
                    this.page_num = 1;
                    this.page_size = 10;
                    this.total = 0;
                    this.$message.success("更新成功");
                } else {
                    this.$message.warning("请求失败！请稍后重试");
                }
            }
        },
        //导表
        async ExportForm() {

            var url = "basicInformation/selectStaffBasicInformation";
            var record = {
            };
            var data = await this.$globals.AxiosPost(url, record);
            if (data === "-2000") {
                this.$message.error("服务器未响应！请稍后重试");
            } else {
                var code = data.code;
                var data = data.data;
                if (code === '200') {
                    this.tableDatas = data.list;
                    this.total = data.total;
                } else {
                    this.$message.warning("请求失败！请稍后重试");
                }
            }

            if (this.tableDatas.length > 0) {
                this.$message.success("导表成功！文件下载中！");
                return this.tableDatas;
            } else {
                this.$message.success("没有可以导出的数据！");
                return null;
            }
        },
        //初始化组织架构及下面的人
        async organizeFind() {
            var organizeList = await this.$globals.AxiosPost("organize/selectOrganizeStaff", {
                identification: "1",
            });
            this.organizeList = this.getTreeData(organizeList.data);

        },
        getTreeData(data) {
            // 循环遍历json数据
            for (var i = 0; i < data.length; i++) {

                if (data[i].organizeList.length < 1) {
                    // children若为空数组，则将children设为undefined
                    data[i].organizeList = undefined;
                } else {
                    // children若不为空数组，则继续 递归调用 本方法
                    this.getTreeData(data[i].organizeList);
                }
            }
            return data;
        }
    },
    created() {
        this.Find();
        this.organizeFind();
    }
}
</script>

<style scoped="scoped">
.el-button--goon:focus,
.el-button--goon:hover {
    background: #006E4B;
    color: #fff;
}

.el-button--goon {
    color: #FFF;
    background-color: #006E4B;
    width: 85px;
}

.el-table .warning-row {
    background: oldlace;
}

.el-table .success-row {
    background: #f0f9eb;
}
</style>


// WEBPACK FOOTER //
// employee_info.vue?fb64ec90